import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = ['Llegás a práctica sin saber exactamente qué ejercicio vas a dar', 'Tus jugadoras no progresan porque no hay un orden claro de contenidos semana a semana', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos sin aburrir a las avanzadas ni frustrar a las que recién empiezan', 'Cuando llueve o hay feriado perdés la continuidad de la planificación y tenés que improvisar de nuevo', 'No podés justificar un aumento de precio porque no tenés nada sistematizado para mostrar', 'Perdés tiempo valioso el domingo buscando ejercicios en internet que ya probaste mil veces', 'El partido llegó y sentís que el equipo no está preparado porque la planificación fue improvisada semana a semana'];
  return <section className="bg-white py-20 px-4" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-[#0284C7] text-center mb-12 uppercase tracking-wide" data-id="element-194">
          Si sos entrenador de hockey, esto te va a sonar conocido:
        </motion.h2>

        <div className="space-y-6 mb-16" data-id="element-195">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 bg-gray-50 p-4 rounded-xl" data-id="element-196">
              <span className="text-red-600 text-xl flex-shrink-0 mt-0.5" data-id="element-197">
                ❌
              </span>
              <p className="text-gray-800 text-lg font-medium" data-id="element-198">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-199">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 italic" data-id="element-200">
            "¿Cuántas prácticas más vas a improvisar?"
          </p>

          <a href="#precio" className="inline-block bg-[#0284C7] hover:bg-[#075985] text-white font-bold text-lg md:text-xl px-8 py-5 rounded-xl shadow-lg transition-all hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-201">
            👉 BASTA DE IMPROVISAR — QUIERO MI HOCKEY 360
          </a>
        </motion.div>
      </div>
    </section>;
}